import { omit } from 'lodash';
import { CustomerSegmentModel } from '@/helpers/entities/models/CustomerSegmentModel';
import { RecipientOrderDetailsModel } from '@/helpers/entities/models/RecipientOrderDetailsModel';
export class PageRecipientDetailsModel {
    constructor(payload) {
        const params = omit(payload, 'customerSegments', 'orders');
        Object.assign(this, params);
        // Safely handle customerSegments
        this.customerSegments = (payload.customerSegments?.edges || []).map((segment) => {
            return new CustomerSegmentModel(segment.node);
        });
        // Safely handle orders
        this.orders = (payload.orders?.edges || []).map((order) => {
            return new RecipientOrderDetailsModel(order.node);
        });
    }
    get segments() {
        return this.customerSegments.map((segment) => {
            return segment.name;
        });
    }
    get defaultProfilePic() {
        if (this.profilePic === ' ' && this.platformOrigin === 'facebook') {
            return require('@/assets/images/messenger-logo.svg');
        }
        return this.profilePic;
    }
}
